import { Box, IconButton, InputAdornment, Modal, TextField, Typography } from '@mui/material'
import React from 'react'
import { BiSearch } from 'react-icons/bi'
import { GrClose } from 'react-icons/gr'
import SaveButton from './SaveButton'
import ResetButton from './ResetButton'

const FilterModal = ({ open, handleClose }) => {
    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 450,
                    height: 900,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography sx={{
                        fontFamily: 'Times New Roman',
                        fontWeight: '700',
                        fontSize: '32px',
                        lineHeight: '36.8px',
                        color: '#545454'
                    }}>Filter</Typography>
                    <IconButton onClick={handleClose}>
                        <GrClose />
                    </IconButton>
                </Box>

                {/* Input Fields */}
                <TextField
                    fullWidth
                    variant="outlined"
                    sx={{
                        width: '450px',
                        border: '1px',
                        borderRadius: '5px',
                        marginBottom: 2,
                        marginTop: 3,
                        borderColor: '#D0D0D0',
                        '& .MuiOutlinedInput-root': {
                            fontFamily: 'Times New Roman',
                            fontSize: '17px',
                            height: '45px', // Set the desired height
                            '& fieldset': {
                                borderColor: '#D0D0D0',
                            },
                            '&:hover fieldset': {
                                borderColor: '#D0D0D0',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#D0D0D0',
                            },

                        },
                        "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: "#272727",
                        },
                    }}
                    placeholder='Search for products & product id'
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton disabled>
                                    <BiSearch />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <Typography sx={{
                    fontFamily: 'Times New Roman',
                    fontWeight: '700',
                    fontSize: '20px',
                    lineHeight: '23px',
                    color: '#302D2D',
                    marginTop: 2
                }}>Issue Date</Typography>
                <TextField fullWidth variant="outlined" type='date' sx={{
                    width: '450px',
                    border: '1px',
                    borderRadius: '5px',
                    marginBottom: 2,
                    marginTop: 2,
                    borderColor: '#D0D0D0',
                    '& .MuiOutlinedInput-root': {
                        fontFamily: 'Times New Roman',
                        fontSize: '17px',
                        height: '45px', // Set the desired height
                        '& fieldset': {
                            borderColor: '#D0D0D0',
                        },
                        '&:hover fieldset': {
                            borderColor: '#D0D0D0',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#D0D0D0',
                        },

                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#272727",
                    },
                }} />

                <Typography sx={{
                    fontFamily: 'Times New Roman',
                    fontWeight: '700',
                    fontSize: '20px',
                    lineHeight: '23px',
                    color: '#302D2D',
                    marginTop: 2
                }}>Category</Typography>
                <TextField fullWidth variant="outlined" sx={{
                    width: '450px',
                    border: '1px',
                    borderRadius: '5px',
                    marginBottom: 2,
                    marginTop: 2,
                    borderColor: '#D0D0D0',
                    '& .MuiOutlinedInput-root': {
                        fontFamily: 'Times New Roman',
                        fontSize: '17px',
                        height: '45px', // Set the desired height
                        '& fieldset': {
                            borderColor: '#D0D0D0',
                        },
                        '&:hover fieldset': {
                            borderColor: '#D0D0D0',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#D0D0D0',
                        },

                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#272727",
                    },
                }} />
                <Typography sx={{
                    fontFamily: 'Times New Roman',
                    fontWeight: '700',
                    fontSize: '20px',
                    lineHeight: '23px',
                    color: '#302D2D',
                    marginTop: 2
                }}>Trail Availability</Typography>
                <TextField fullWidth variant="outlined" sx={{
                    width: '450px',
                    border: '1px',
                    borderRadius: '5px',
                    marginBottom: 2,
                    marginTop: 2,
                    borderColor: '#D0D0D0',
                    '& .MuiOutlinedInput-root': {
                        fontFamily: 'Times New Roman',
                        fontSize: '17px',
                        height: '45px', // Set the desired height
                        '& fieldset': {
                            borderColor: '#D0D0D0',
                        },
                        '&:hover fieldset': {
                            borderColor: '#D0D0D0',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#D0D0D0',
                        },

                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#272727",
                    },
                }} />
                <Typography sx={{
                    fontFamily: 'Times New Roman',
                    fontWeight: '700',
                    fontSize: '20px',
                    lineHeight: '23px',
                    color: '#302D2D',
                    marginTop: 2
                }}>Status</Typography>
                <TextField fullWidth variant="outlined" sx={{
                    width: '450px',
                    border: '1px',
                    borderRadius: '5px',
                    marginBottom: 2,
                    marginTop: 2,
                    borderColor: '#D0D0D0',
                    '& .MuiOutlinedInput-root': {
                        fontFamily: 'Times New Roman',
                        fontSize: '17px',
                        height: '45px', // Set the desired height
                        '& fieldset': {
                            borderColor: '#D0D0D0',
                        },
                        '&:hover fieldset': {
                            borderColor: '#D0D0D0',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#D0D0D0',
                        },

                    },
                    "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#272727",
                    },
                }} />
                {/* Apply Button */}
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Box mr={2}> {/* Add margin to the right */}
                        <SaveButton label={"Apply"} />
                    </Box>
                    <ResetButton label={"Cancel"} />
                </Box>
            </Box>
        </Modal>
    )
}

export default FilterModal